import * as Yup from 'yup';

export const passwordValidationSchema =
    Yup.object().shape({
        newPassword: Yup.string()
            .required('Заполните поле')
            .min(8, 'Длина пароля должна быть не меньше 8 символов')
            .max(128, 'Длина пароля должна быть меньше 128 символов'),
        newPasswordConfirmation: Yup.string()
            .required('Заполните поле')
            .when('newPassword', {
                is: val => val && val.length > 0,
                then: () => Yup.string()
                    .oneOf([ Yup.ref('newPassword') ], 'Пароли должны совпадать')
                    .required('Обязательное поле')
            }),
    });
